export function humaniseKey(key) {
  let normalized = key;
  if (normalized.toLowerCase() === "id") {
    return "Record";
  }
  if (/_id$/i.test(normalized)) {
    normalized = normalized.replace(/_id$/i, "");
  }
  return normalized.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export function formatAuditDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString("en-CA", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

const RECORD_LABEL_KEYS = [
  "name",
  "name_en",
  "plu",
  "po_number",
  "invoice_number",
  "lot_number",
  "barcode",
  "number",
  "vendor_sku",
];

export function getAuditRecordLabel(event) {
  const metadata = event?.metadata;
  if (!metadata) return null;

  if (event?.entity?.label) return String(event.entity.label);

  const snapshot = metadata.snapshot;
  if (snapshot) {
    for (const key of RECORD_LABEL_KEYS) {
      if (snapshot[key]) return String(snapshot[key]);
    }
  }

  const changes = metadata.changes ?? {};
  for (const key of RECORD_LABEL_KEYS) {
    if (changes[key]?.to) return String(changes[key].to);
    if (changes[key]?.from) return String(changes[key].from);
  }

  return null;
}

export function getAuditDisplayAction(metadata) {
  if (metadata?.context?.child_added) return "added";
  if (metadata?.context?.child_removed) return "removed";

  return metadata?.action;
}

function formatLineItem(item) {
  if (!item || typeof item !== "object") return String(item ?? "");
  const name =
    item.bom_name || item.name || item.label || `#${item.bom_id ?? item.id ?? "?"}`;
  const parts = [name];
  if (item.quantity != null && item.quantity !== "")
    parts.push(`qty ${item.quantity}`);
  if (item.barcode) parts.push(item.barcode);
  return parts.join(" · ");
}

export function formatAuditRelationValue(relationKey, val) {
  if (val === null || val === undefined || val === "") return null;
  if (!Array.isArray(val)) return String(val);
  if (val.length === 0) return null;

  const first = val[0];
  if (first && typeof first === "object") {
    return val.map(formatLineItem);
  }

  return val.map(String);
}

export function formatAuditContext(context) {
  if (!context || typeof context !== "object") return null;
  const notes = [];
  const childSummary = context.child_added?.summary ?? context.child_removed?.summary;
  const summary = context.summary ?? childSummary;

  if (summary) notes.push(String(summary));
  if (context.password_changed) notes.push("Password changed");
  if (context.pin_changed) notes.push("PIN changed");
  return notes.length > 0 ? notes.join(" · ") : null;
}
